<template>
  <b-row>
    <b-col cols="12">
      <b-row class="justify-content-between mb-3">
        <b-col cols="3" sm="6" md="3" class="d-flex align-items-end">
          <div>
            <label for="input">Rechercher</label>
            <b-input-group>
              <template #append>
                <b-input-group-text
                  v-if="!hasSearchInputBeenReseted || isSearchInputFocused || searchParams"
                  type="button"
                  @click="resetSearch"
                >
                  <font-awesome-icon icon="times" size="sm"></font-awesome-icon>
                </b-input-group-text>
              </template>

              <b-form-input
                id="input"
                v-model="searchParams"
                placeholder="Tapez pour rechercher"
                @focus="focusSearch"
                @blur="unfocusSearch"
                @keyup.enter="search"
              />
            </b-input-group>
            <small class="text-secondary ml-2"
              >Utilisez la touche Entrée pour lancer la recherche</small
            >
          </div>
        </b-col>
        <b-col cols="3" sm="6" md="3">
          <label>par page</label>
          <b-select
            v-model="pagination.pageSize"
            :options="[10, 20, 50, 100]"
            @input="getBuildings"
          ></b-select>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <b-table
        class="agv-table td-middle"
        bordered
        :items="buildings"
        :fields="fields"
        :busy="isBusy"
        show-empty
      >
        <!-- Heads -->
        <template #head(name)>
          <div class="d-flex align-items-center">
            <span class="mr-2" @click="setSort('name')">Nom</span>
            <font-awesome-icon
              v-if="tableHeaderSettings.sort.by == 'name' && tableHeaderSettings.sort.dir == 'desc'"
              icon="sort-up"
              @click="setSort('name', 'asc')"
            ></font-awesome-icon>
            <font-awesome-icon
              v-else-if="
                tableHeaderSettings.sort.by == 'name' && tableHeaderSettings.sort.dir == 'asc'
              "
              icon="sort-down"
              @click="setSort('name', 'desc')"
            ></font-awesome-icon>
            <font-awesome-icon v-else icon="sort" @click="setSort('name')"></font-awesome-icon>
          </div>
        </template>
        <template #head(address)>
          <div class="d-flex align-items-center">
            <span class="mr-2" @click="setSort('address')">Adresse</span>
            <font-awesome-icon
              v-if="
                tableHeaderSettings.sort.by == 'address' && tableHeaderSettings.sort.dir == 'desc'
              "
              icon="sort-up"
              @click="setSort('address', 'asc')"
            ></font-awesome-icon>
            <font-awesome-icon
              v-else-if="
                tableHeaderSettings.sort.by == 'address' && tableHeaderSettings.sort.dir == 'asc'
              "
              icon="sort-down"
              @click="setSort('address', 'desc')"
            ></font-awesome-icon>
            <font-awesome-icon v-else icon="sort" @click="setSort('address')"></font-awesome-icon>
          </div>
        </template>
        <!-- Rows-->
        <template v-slot:cell(name)="row">
          <div class="text-left">
            <appTextArea
              :ref="'name-' + row.item.id"
              :text="row.item.name"
              :property="'name'"
              :item-id="row.item.id"
              class="min-w-130"
              @update="updateProperty"
            ></appTextArea>
          </div>
        </template>
        <template v-slot:cell(address)="row">
          <div class="text-left">
            <appTextArea
              :ref="'address-' + row.item.id"
              :text="row.item.address"
              :property="'address'"
              :item-id="row.item.id"
              class="min-w-130"
              @update="updateProperty"
            ></appTextArea>
          </div>
        </template>
        <template v-slot:cell(_actions)="row">
          <div class="d-flex justify-content-center">
            <b-button
              v-show="!hasChargesGenerales(row.item.id)"
              class="tablebutton btn-edit"
              title="Il n'y a pas de charges générales pour ce bâtiment !"
              variant="white"
              @click="editBuilding(row.item, 7)"
            >
              <font-awesome-icon class="text-warning" icon="exclamation-triangle" size="2x" />
            </b-button>
            <b-button
              class="tablebutton btn-edit"
              title="Modifier la immeuble copropriétaires"
              variant="white"
              @click="editBuilding(row.item, 5)"
            >
              <font-awesome-icon icon="users" size="2x" />
            </b-button>
            <b-button
              class="tablebutton btn-edit"
              variant="white"
              title="Modifier la immeuble"
              @click="editBuilding(row.item)"
            >
              <font-awesome-icon icon="pen" size="2x" />
            </b-button>
            <b-button
              class="tablebutton btn-red"
              variant="white"
              title="Supprimer la immeuble"
              @click="deleteBuilding(row.item)"
            >
              <font-awesome-icon icon="trash-alt" size="2x" />
            </b-button>
          </div>
        </template>
        <template #table-busy>
          <appIsLoading />
        </template>
        <template #empty>
          <span>{{ "Aucune donnée n'a été trouvée..." }}</span>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="text-center">
      <b-col cols="4" class="m-auto d-flex justify-content-center">
        <b-pagination
          v-model="pagination.page"
          :total-rows="pagination.rowCount"
          :per-page="pagination.pageSize"
          aria-controls="mt-table"
          @input="getBuildings"
        ></b-pagination>
      </b-col>
    </b-col>
  </b-row>
</template>
<script>
import BuildingMW from "@/middlewares/Building";
import BuildingORM from "@/store/orm-axios/models/Building";
export default {
  components: {
    appTextArea: () => import("@/components/b-table-components/TextArea"),
    appCheckbox: () => import("@/components/b-table-components/VCheckbox"),
    appIsLoading: () => import("@/components/snippets/IsLoading"),
  },
  data() {
    return {
      tableData: [],
      fields: [
        {
          key: "name",
          label: "Nom",
        },
        {
          key: "address",
          label: "Adresse",
        },
        {
          key: "_actions",
          label: "Actions",
        },
      ],
      pagination: {
        page: 1,
        pageSize: 10,
        rowCount: 0,
        pageCount: 0,
      },
      tableHeaderSettings: {
        filter: [
          {
            column: "name",
            value: "",
          },
        ],
        sort: {
          by: "created",
          dir: "desc",
        },
      },
      isBusy: true,
      searchParams: "",
      isSearchInputFocused: false,
      hasSearchInputBeenReseted: true,
    };
  },
  computed: {
    agencyId() {
      return Number(localStorage.getItem("agencyId"));
    },
    buildings() {
      return BuildingORM.query()
        .where("agency_id", this.agencyId)
        .limit(this.pagination.pageSize)
        .orderBy("created", "desc")
        .get();
    },
    buildingProperties() {
      return [
        "id",
        "name",
        "address",
        "agency_id",
        "created",
        "asl",
        { votingCategories: ["id", "is_charge_generale"] },
      ];
    },
  },
  async created() {
    let queryParams = this.prepareQueryParams();
    await BuildingMW.QUERY_FETCH_WITH_PROPERTIES_AND_PAGINATION(
      this.agencyId,
      queryParams,
      this.buildingProperties
    )
      .then(res => {
        let totalItems = res.response.data["hydra:totalItems"];
        this.pagination.rowCount = totalItems;
        this.tableData = res.response.data["hydra:member"];
        this.isBusy = false;
      })
      .catch(err => {
        this.isBusy = false;
      });
  },
  beforeDestroy() {
    BuildingORM.deleteAll();
  },
  methods: {
    prepareQueryParams() {
      var queryParams = {
        filter: [],
        sort: {},
      };
      if (this.tableHeaderSettings.sort.by && this.tableHeaderSettings.sort.dir) {
        queryParams.sort["by"] = this.tableHeaderSettings.sort.by;
        queryParams.sort["dir"] = this.tableHeaderSettings.sort.dir;
      }
      this.tableHeaderSettings.filter.forEach(filter => {
        if (!!filter.value || filter.value === 0) {
          var preparedFilter = {
            column: filter.column,
            value: filter.value,
          };
          queryParams.filter.push(preparedFilter);
        }
      });
      return queryParams;
    },
    async getBuildings() {
      this.isBusy = true;
      var queryParams = this.prepareQueryParams();
      await BuildingMW.FETCH_BY_PAGE(
        this.agencyId,
        queryParams,
        this.buildingProperties,
        this.pagination
      )
        .then(res => {
          let totalItems = res.response.data["hydra:totalItems"];
          this.pagination.rowCount = totalItems;
          this.tableData = res.response.data["hydra:member"];
          this.isBusy = false;
        })
        .catch(err => {
          this.isBusy = false;
          console.error(err);
        });
    },
    setSort(by, dir) {
      if (!dir) {
        if (this.tableHeaderSettings.sort.dir == "asc") {
          dir = "desc";
        } else {
          dir = "asc";
        }
      }
      this.tableHeaderSettings.sort.by = by;
      this.tableHeaderSettings.sort.dir = dir;
      this.getBuildings();
    },
    async updateProperty($ev) {
      let building = BuildingORM.query().where("id", $ev.itemId).first();
      building[$ev.property] = $ev.value;
      await BuildingMW.PUT(building).catch(err => {
        console.error(err);
      });
    },
    editBuilding(building, stepNr = false) {
      this.isBusy = true;
      if (!stepNr) {
        if (building.asl == 1) {
          this.$router.push({ name: "edit-building-asl", params: { id: building.id } });
        } else {
          this.$router.push({ name: "edit-building", params: { id: building.id } });
        }
      } else {
        if (building.asl == 1) {
          this.$router.push({
            name: "edit-building-asl",
            params: { id: building.id, step: stepNr },
          });
        } else {
          this.$router.push({ name: "edit-building", params: { id: building.id, step: stepNr } });
        }
      }
    },
    deleteBuilding(building) {
      var self = this;
      self
        .$swal(self.alertQuestion())
        .then(res => {
          if (res.value) {
            BuildingMW.CUSTOM_DELETE(building.id)
              .then(res2 => {
                if (
                  res2.response.data &&
                  res2.response.data.error &&
                  res2.response.data.error.includes("Cannot delete or update a parent")
                ) {
                  self.$swal(
                    self.alertWarning(
                      undefined,
                      "Cet élément ne peut pas être supprimé car il a des convocations qui sont assignés !"
                    )
                  );
                } else {
                  BuildingORM.delete(building.id);
                }
              })
              .catch(err => {
                console(err);
              });
          }
        })
        .catch(err => {
          console.err(err);
          self.$swal(self.alertError());
        });
    },
    hasChargesGenerales(buildingId) {
      let hasChargesGenerales = false;
      let building = BuildingORM.query()
        .where("id", buildingId)
        .where("agency_id", this.agencyId)
        .with("voting_categories")
        .first();
      if (building && building.voting_categories) {
        building.voting_categories.forEach(votingCategory => {
          if (votingCategory.is_charge_generale == 1) {
            hasChargesGenerales = true;
          }
        });
      }
      return hasChargesGenerales;
    },
    search() {
      if (this.isBusy) return;

      this.hasSearchInputBeenReseted = false;

      this.tableHeaderSettings.filter[0].value = this.searchParams;
      this.getBuildings();
    },
    focusSearch() {
      this.isSearchInputFocused = true;
    },
    unfocusSearch() {
      this.isSearchInputFocused = false;
    },
    resetSearch() {
      this.hasSearchInputBeenReseted = true;
      this.isSearchInputFocused = false;

      this.searchParams = "";
      this.tableHeaderSettings.filter[0].value = this.searchParams;
      this.getBuildings();
    },
  },
};
</script>
